export interface TileSource {
  id: string;
  /** Mẫu URL với {z}/{x}/{y}. */
  urlTemplate: string;
  /** Bắt buộc hiển thị theo giấy phép dữ liệu. */
  attribution: string;
  maxZoom?: number;
}

/**
 * Nguồn tile mặc định (chỉ OSM: CARTO basemaps hiện yêu cầu API key nên KHÔNG dùng làm dự phòng mặc định; cấu hình nguồn dự phòng qua VITE_MAP_TILES_FALLBACK_URL). ⚠ Chỉ dùng cho phát triển/demo:
 * khi chạy thật hãy trỏ tới tile server của Green SM (cấu hình qua VITE_MAP_TILES_*), tuân thủ chính sách sử dụng của OSM.
 */
export const DEFAULT_TILE_SOURCES: TileSource[] = [
  { id: 'osm', urlTemplate: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png', attribution: '© OpenStreetMap contributors', maxZoom: 19 },
  // 14/10: dự phòng không cần khóa khi tile.openstreetmap.org chập chờn (thẻ báo giá từng báo "Không tải được
  // bản đồ nền"). Cùng dữ liệu OSM, máy chủ OSM France (kiểu HOT); chỉ dùng cho phát triển/demo.
  { id: 'osm-fr-hot', urlTemplate: 'https://a.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png', attribution: '© OpenStreetMap contributors · OSM France', maxZoom: 19 },
];

export const tileUrl = (s: TileSource, z: number, x: number, y: number): string =>
  s.urlTemplate.replace('{z}', String(z)).replace('{x}', String(x)).replace('{y}', String(y));

let current: TileSource[] = DEFAULT_TILE_SOURCES;

/** Đặt nguồn tile dùng mặc định cho mọi <MapView>. Gọi một lần khi khởi động app. */
export const configureTileSources = (sources: TileSource[]): void => { if (sources.length) current = sources; };
export const getTileSources = (): TileSource[] => current;

/** Dựng danh sách nguồn từ cấu hình môi trường: tile riêng của Green SM (chính) + tuỳ chọn nguồn dự phòng. */
export function tileSourcesFromConfig(cfg: { url?: string; attribution?: string; fallbackUrl?: string }): TileSource[] {
  if (!cfg.url) return DEFAULT_TILE_SOURCES;
  const attribution = cfg.attribution || '© Green SM · © OpenStreetMap contributors';
  const list: TileSource[] = [{ id: 'primary', urlTemplate: cfg.url, attribution }];
  if (cfg.fallbackUrl) list.push({ id: 'fallback', urlTemplate: cfg.fallbackUrl, attribution });
  return list;
}
